import { profileSlice } from './reducer';

export const { LOGIN, LOGOUT, SETTOKEN, SETISLOGIN } = profileSlice.actions;
